import { z } from "zod";
import { noAnswerSchema, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  charset: z.enum(["numbers", "letters", "alphanumeric"]).default("alphanumeric"),
  length: z.number().int().min(4).max(32).default(8),
  // "restrict repetition" — enforces uniqueness within the form via random_id_registry with
  // bounded retry (docs/01-PRODUCT-SPEC.md §3.2, docs/02-DATA-MODEL.md).
  restrictRepetition: z.boolean().default(true),
});

export const randomIdField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "random_id",
  label: "Random identifier",
  category: "identifier",
  icon: "Shuffle",
  configSchema,
  valueSchema: () => noAnswerSchema(),
  defaultConfig: { charset: "alphanumeric", length: 8, restrictRepetition: true },
  supportsProfileBinding: false,
  defaultSearchable: true,
  renderHints: { isHiddenFromApplicant: true },
};
